// Lib imports
import Vue from 'vue';
import Vuex from 'vuex';

import createPersistedState from 'vuex-persistedstate';
import Config from '../configuration';
import vuexI18n from 'vuex-i18n';

import AppModule from './AppModule';
import ClaimsModule from './ClaimsModule';
import RepaymentsModule from './RepaymentsModule';
import UserModule from './UserModule';
import FactoringModule from './FactoringModule';
import ApplicationModule from './ApplicationModule';
import SummaryModule from './SummaryModule';
import TransfersModule from './TransfersModule';
import NotificationModule from './NotificationModule';
import TranslationsModule from './TranslationsModule';

// Store functionality

Vue.use(Vuex);

// Create a new store
export default new Vuex.Store({

	strict: true,
	modules: {
		app: AppModule,
		claims: ClaimsModule,
		repayments: RepaymentsModule,
		user: UserModule,
		factorings: FactoringModule,
		applications: ApplicationModule,
        transfers: TransfersModule,
		notification: NotificationModule,
		translations: TranslationsModule,
		summary: SummaryModule
	},
	state: {
		notification: {
			show: false,
			message: ''
		},
		credentials: {
			token: '',
			refreshToken: '',
			expiration: new Date('2000-01-01 00:00:00'),
			isAuthorized: false
		},
		selectedLang: 'is',
		backLink: '',
		downloadedLanguages: {},
		audkenniGuid: ''
	},
	mutations: {
		// translations
		setLang (state, lang)
		{
			let self = this;
			state.selectedLang = lang;

			Vue.i18n.set(lang);

			if (!state.downloadedLanguages.hasOwnProperty(state.selectedLang))
			{
				self.commit('updateTranslations', lang)
			}
		},
		updateTranslations (state, lang)
		{
			let fetchTranslations = this.dispatch('translations/getTranslationsDictionary');

			fetchTranslations.then(response =>
			{
				let translations = response;
				Vue.i18n.replace(lang,translations);
				state.downloadedLanguages[lang] = true;
			})
		},
		clearDownloadedLanguagesList (state)
		{
			state.downloadedLanguages = {}
		},
		//token
		setToken (state, token)
		{
			state.credentials.token = token;
		},
		setRefreshToken (state, token){
			state.credentials.refreshToken = token;
		},
		setExpirationDate (state, expire)
		{
			state.credentials.expiration = expire;
		},
		setAuthorized (state, payload)
		{
			state.credentials.isAuthorized = payload;
		},
		setUnauthorized (state, isAuthorized)
		{
			state.credentials.isAuthorized = isAuthorized;
			state.credentials.isAuthorized = false;
		},
		//user
		storeBackLink (state, payload)
		{
			state.backLink = payload;
		},
		setUser (state, payload)
		{
			state.userInfo = payload;
			this.commit('updateTranslations',state.i18n.locale);
		},
		setCompany (state,payload)
		{
			state.userInfo = payload;
		},
		logOut (state)
		{
			state.credentials.token = '';
			state.credentials.refreshToken = '';
			state.credentials.isAuthorized = false;
			state.backLink = '';
			state.userInfo = null;
		},
		setAudkenniGuid(guid) {
			state.audkenniGuid = guid;
		}
	},
	actions: {
		getToken: function (context, payload)
		{
			return new Promise (function (resolve, reject)
			{
				Vue.axios.post(Config.GetUrl(Config.kritaApi) + 'login', {
					'user': payload.user,
					'password': payload.password,
				}).then(function (response)
				{
					context.commit('setToken', response.data['access_token']);
					if(payload.rememberLogin ===true)
					{
						context.commit('setRefreshToken', response.data['refresh_token']);
					}

					let expiration = new Date();
					expiration.setSeconds(expiration.getSeconds() + response.data['expires_in']);
					context.commit('setExpirationDate', expiration);
					resolve();
				}, () =>
				{
					reject(new Error('unauthorized'));
				});
			});
		},
		getTokenFromRefresh (context, payload){
			return new Promise (function (resolve, reject)
			{
				Vue.axios.post(Config.GetUrl(Config.kritaApi) + 'login', {
					'refreshToken': context.state.credentials.refreshToken,
				}).then(function (response)
				{
					context.commit('setToken', response.data['access_token']);
					if(payload.rememberLogin ===true)
					{
						context.commit('setRefreshToken', response.data['refresh_token']);
					}

					let expiration = new Date();
					expiration.setSeconds(expiration.getSeconds() + response.data['expires_in']);
					context.commit('setExpirationDate', expiration);
					context.commit('setAuthorized', true);
					resolve();
				}, () =>
				{
					reject(new Error('unauthorized'));
				});
			});
		},
		checkAuthentication: function (context, payload)
		{
			return new Promise(function (resolve, reject)
			{
				if (window.Refresh)
				{
					window.Refresh = false;
					// context.state.credentials.isAuthorized = false;
					context.commit('setAuthorized', false);
				}
				resolve();
			});
		},
		checkTokenValidity (context)
		{
			return new Promise(function (resolve, reject)
			{
				Vue.axios.get(Config.GetUrl(Config.kritaApi) + 'token', {
				}).then(function (response)
				{
					if (response.data.HasError)
					{
						reject(new Error(response.data.Errors[0]));
					}
					else
					{
						self.$store.commit('setAuthorized',true);
						resolve(response);
					}
				}, (fail) =>
				{
					resolve(fail);
				});
			});
		},
		
		getAudkenniToken: function (context, payload)
		{
			function ensureFooIsSet(guidStr) {
				console.log('ensure: ' + guidStr);
				return new Promise((resolve, reject) => {
					(function waitForFoo(guidStr){

						console.log('in promise: ' + guidStr);
						Vue.axios.get(Config.GetUrl(Config.kritaApi) + 'Audkenni/Poll', {
							params: { 'guidStr': guidStr }
						}).then( (response) => {
							if(response.status == 201){

								return new Promise(function(resolve, reject) { 
									setTimeout(() => {
										// console.log('1 second expired seconds Timer expired!!!');
										waitForFoo(guidStr);
										resolve();
									}, 1000),
									() => {
										reject('error from promise');
									}});
							} 
							else if(response.status == 200) { //finished
								console.log('Polling finished !');
								resolve(response);
							} else {
								console.log('Unexpected error');
								console.log(response);
								reject(); // should not happen!
							};
						}, (error) => { 
							console.log('Error ' + error.response.status);
							reject('Audkenni authorization failed'); 
						});
						

					})(guidStr);
				});
			}

			return new Promise (function (resolve, reject)
			{
				Vue.axios.post(Config.GetUrl(Config.kritaApi) + 'Audkenni/Authorize', {
					'phone': payload.phone,
					'kennitala': '',
				})
				.then( (response) => {
					let guid = response.data['Guid'];
					console.log(response.data);
					console.log(guid);					
					return ensureFooIsSet(guid);

					})
				.then( (response) => {
					console.log(response);
					let data = JSON.parse(response.data);
					context.commit('setToken', data['access_token']);
					if(payload.rememberLogin ===true)
					{
						context.commit('setRefreshToken', data['refresh_token']);
					}

					let expiration = new Date();
					expiration.setSeconds(expiration.getSeconds() + data['expires_in']);
					context.commit('setExpirationDate', expiration);
					//self.getUser();
					resolve();
				}, error => 
					{
						reject(new Error('Unexpected error'));
					})
				;
			});
		},

	},
	plugins: [createPersistedState()],
});
